import React from 'react'
import Popup from './Popup';
var functions = require("./functions.js");

// HubSettingsPopup component
export default class HubSettingsPopup extends React.Component {


    // render
    render() {

        return(true) ? (
            <Popup className="hub-test-history-popup"  trigger={ this.props.hubSettingVisible }>
                <div className="align-right">
                    <button className="close-btn" onClick={() => this.props.closeHubSettingsPopup() }>Close</button>
                </div>
                <h3>
                    Generate Edit Hub Settings Command - {this.props.hubSetting.label}
                    <button className="" title="command to connect to hub from AWS Bastion Host Gateway will be put into clipboard" onClick={() => functions.openWindow( functions.getSSHUrlForGateway(this.props.hub.hostname+".hubs.wavedds.com") ) }>AWS Bastion Host Gateway<img alt='' height="15px" src="icons8-clone-figure-32.png"></img></button>
                </h3>
                <input id="newValue" defaultValue={this.props.hubSetting.value} onChange={this.changeValue.bind(this)}></input>
                ****** DON'T USE SINGLE OR DOUBLE QUOTES
                <h5>Code  <button className="" title="Code will be copied to clipboard" onClick={() => functions.copyToClipBoard(document.getElementById("generatedCode").value)  }>Copy Code to Clipboard<img alt='' height="15px" src="icons8-clone-figure-32.png"></img></button>:</h5>
                <textarea id="generatedCode"></textarea>
            </Popup>  
        ):"";
    }

    changeValue(){
        let cmd = `curl -X PUT 'http://localhost:$port/api/setting/${this.props.hubSetting.key}' -H  'accept: application/json' -H  'Content-Type: application/json' -d '{  "value": "${document.getElementById("newValue").value}"}'\n`;
        document.getElementById("generatedCode").value=cmd;

    }
   
}

